export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_sw-100b43d198b9211649406f902e25e3d9.png";